import React from 'react';

/**
 * Popup que muestra cuando el veterinario está en período de gracia
 * Se muestra una vez por sesión para no ser intrusivo
 */
const GraciaPopup = ({ diasRestantes, pacientesEnGracia = [], onClose }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '16px'
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          maxWidth: '500px',
          width: '100%',
          boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden'
        }}
      >
        {/* Header */}
        <div
          style={{
            backgroundColor: '#f59e0b',
            padding: '16px 20px',
            color: 'white'
          }}
        >
          <h5 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span role="img" aria-label="warning">⚠️</span>
            Aviso importante
          </h5>
        </div>

        {/* Body */}
        <div style={{ padding: '20px' }}>
          {pacientesEnGracia.length > 0 ? (
            <>
              <p style={{ marginBottom: '12px', color: '#374151' }}>
                Tus pacientes Premium están en período de gracia:
              </p>
              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: '0 0 16px 0',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              >
                {pacientesEnGracia.map((p, i) => (
                  <li
                    key={i}
                    style={{
                      padding: '12px 16px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderBottom: i < pacientesEnGracia.length - 1 ? '1px solid #e5e7eb' : 'none',
                      backgroundColor: '#fafafa'
                    }}
                  >
                    <span style={{ color: '#374151' }}>
                      {p.mascotaNombre} <span style={{ color: '#9ca3af' }}>({p.duenoNombre})</span>
                    </span>
                    <span
                      style={{
                        backgroundColor: '#fef3c7',
                        color: '#92400e',
                        padding: '4px 10px',
                        borderRadius: '12px',
                        fontSize: '13px',
                        fontWeight: '500'
                      }}
                    >
                      {p.diasRestantes} días
                    </span>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <p style={{ marginBottom: '12px', color: '#374151' }}>
              Tu período de gracia está activo.
            </p>
          )}

          <p style={{ color: '#6b7280', marginBottom: '16px' }}>
            Si ninguno renueva su plan, perderás acceso al sistema en{' '}
            <strong style={{ color: '#374151' }}>{diasRestantes} días</strong>.
          </p>

          {/* Info box */}
          <div
            style={{
              backgroundColor: '#eff6ff',
              border: '1px solid #bfdbfe',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '0'
            }}
          >
            <strong style={{ color: '#1e40af', display: 'block', marginBottom: '8px' }}>
              ¿Quieres operar de forma independiente?
            </strong>
            <a
              href="mailto:soporte@lemmontags.com?subject=Plan%20Veterinario%20Independiente"
              style={{
                display: 'inline-block',
                backgroundColor: 'white',
                color: '#2563eb',
                border: '1px solid #2563eb',
                padding: '8px 16px',
                borderRadius: '6px',
                textDecoration: 'none',
                fontSize: '14px',
                marginTop: '4px'
              }}
            >
              Contactar a soporte
            </a>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: '16px 20px',
            borderTop: '1px solid #e5e7eb',
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <button
            onClick={onClose}
            style={{
              backgroundColor: '#84cc16',
              color: 'white',
              border: 'none',
              padding: '10px 24px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default GraciaPopup;
